import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PROTECTED } from 'lib/routes'
import { useUser } from 'hooks/users'
import Avatar from '../Profile/Avatar.js'
import { formatDistanceToNowStrict } from 'date-fns';
import NameButton from 'components/MainApp/Profile/nameButton.js';
import Actions from './Actions.js';

import 'stylesheets/MainAppStyles/HeaderNote.css'
import 'stylesheets/MainAppStyles/NoteListEl.css'
import 'stylesheets/Skeletons/NoteListElement.css'
const NoteListEl = ({ note }) => {
    const navigate = useNavigate()
    const handleNoteClick = () => {
        navigate(`${PROTECTED}/comments/${note.id}`)
    }

    const { uid, title, text, date } = note
    const { user, isLoading } = useUser(uid);

    if (isLoading) return (
        <div className="note-list-el-main-container">
            <div className="note-header-container">
                <div className="avatar-loading"></div>
                <div className="note-header-info">
                    <div className="header-user-info"></div>
                    <div className="note-content-container"></div>
                    <div className="actions-main-container"></div>
                </div>
            </div>
        </div>
    )
    return (
        <div className='note-list-el-main-container' onClick={handleNoteClick}>
            <div className='note-header-container'>
                <Avatar user={user} />
                <div className='note-header-info'>
                    <div className='header-user-info'>
                        <NameButton user={user} />
                        <p>@{user.username}</p>
                        <p>· {formatDistanceToNowStrict(date, false)} ago</p>
                    </div>
                    <div className='note-content-container'>
                        <h1 className='note-title'>
                            {title}
                        </h1>
                    </div>
                    <Actions note={note} />
                </div>
            </div>
        </div>
    )
}

export default NoteListEl